import { render, staticRenderFns, recyclableRender, components } from "./problemReporting.vue?vue&type=template&id=a5061d34&scoped=true&"
var renderjs
import script from "./problemReporting.vue?vue&type=script&lang=js&"
export * from "./problemReporting.vue?vue&type=script&lang=js&"
import style0 from "./problemReporting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./problemReporting.vue?vue&type=style&index=1&id=a5061d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5061d34",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/problemReporting/problemReporting.vue"
export default component.exports